import React from "react";

/**
 * Universal circular avatar.
 * - Supports image via AuthImage path or plain URL
 * - Falls back to initials with emerald background
 * - `ring` shows the emerald glow ring
 */
import AuthImage from "./AuthImage";

const SIZES = {
  xs: 24, sm: 32, md: 40, lg: 56, xl: 80, "2xl": 112,
};

export default function Avatar({ name = "", src, size = "md", ring = false, className = "" }) {
  const px = typeof size === "number" ? size : SIZES[size] || 40;
  const initial = (name || "?").trim().charAt(0).toUpperCase() || "?";
  const fontSize = Math.round(px * 0.42);
  return (
    <span
      className={`avatar ${ring ? "avatar-ring" : ""} ${className}`}
      style={{ width: px, height: px, fontSize }}
    >
      {src ? (
        <AuthImage
          src={src}
          className="w-full h-full object-cover"
          fallback={<span>{initial}</span>}
        />
      ) : (
        <span>{initial}</span>
      )}
    </span>
  );
}
